import type { Organization } from '#/domain/organization/Organization'
import type { OrganizationRepository } from '#/domain/organization/OrganizationRepository'

export class UpdateOrganizationUseCase {
  constructor(private readonly repository: OrganizationRepository) {}

  async execute(organization: Organization): Promise<Organization> {
    return this.repository.update(organization)
  }
}
